export const logo = require('../assets/img/normal.png');